var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.155366 0.155366C0.254975 0.05588 0.390001 0 0.530783 0C0.671564 0 0.80659 0.05588 0.906199 0.155366L9.4062 8.65536C9.45839 8.704 9.50026 8.76265 9.52929 8.82782C9.55833 8.89298 9.57394 8.96333 9.5752 9.03466C9.57646 9.10599 9.56334 9.17685 9.53662 9.243C9.5099 9.30915 9.47013 9.36924 9.41968 9.41968C9.36924 9.47013 9.30915 9.5099 9.243 9.53662C9.17685 9.56334 9.10599 9.57646 9.03466 9.5752C8.96333 9.57394 8.89298 9.55833 8.82782 9.52929C8.76265 9.50026 8.704 9.45839 8.65536 9.4062L0.155366 0.906199C0.05588 0.80659 0 0.671564 0 0.530783C0 0.390001 0.05588 0.254975 0.155366 0.155366Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.40611 0.155366C9.5056 0.254975 9.56148 0.390001 9.56148 0.530783C9.56148 0.671564 9.5056 0.80659 9.40611 0.906199L0.90611 9.4062C0.805403 9.50004 0.672203 9.55113 0.534573 9.5487C0.396944 9.54627 0.265629 9.49051 0.168295 9.39318C0.0709606 9.29585 0.0152064 9.16453 0.0127781 9.0269C0.0103498 8.88927 0.0614368 8.75607 0.155277 8.65536L8.65528 0.155366C8.75489 0.05588 8.88991 0 9.03069 0C9.17148 0 9.3065 0.05588 9.40611 0.155366Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e3488f5c4020a5ec1b1b0252fe3c8d36.svg";
export { ForwardRef as ReactComponent };